import React, { useContext } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import MainFrame from './MainFrame';
import SignIn from '../pages/SignIn';

const Router = () => {
  const {isAuth, signIn, signOut } = useContext(AuthContext);

  return (
    <BrowserRouter>
        {
          isAuth 
          ? <MainFrame isAuth={isAuth} signOut={signOut}/>
          : (
              <Switch>
                <Route 
                  path={'/signin'} 
                  render={(props) => <SignIn {...props} signIn={signIn} />} 
                />
                <Redirect from="/" to="/signin" />
              </Switch>
          )
        }
    </BrowserRouter>
  )
}

export default Router;